export default "__VITE_ASSET__BIUC1TUV__"